<div class="container">
     <div class=" py-2 px-3 my-4">
       <h2 class="slideOff"><i class="fa fa-users" aria-hidden="true"></i> Customers</h2>
     </div>
     <div class="row">
       <!-- first name input search -->
      <div class="col-lg-3 d-flex">
        <div class="input-group-prepend">
          <span class="input-group-text d-block" id="basic-addon1">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
        </div>
        <input (input)="searchByFirstName($event)" type="text" class="form-control" placeholder="First name" >
      </div>
      <!-- last name input search -->
      <div class="col-lg-3 d-flex">
        <div class="input-group-prepend">
          <span class="input-group-text d-block" id="basic-addon1">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
        </div>
        <input (input)="searchByLastName($event)" type="text" class="form-control" placeholder="Last name" >
      </div>
      <!-- phone input search -->
       <div class="col-lg-3 d-flex">
        <div class="input-group-prepend">
          <span class="input-group-text d-block" id="basic-addon1">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
        </div>
        <input (input)="searchByPhone($event)" type="text" class="form-control" placeholder="Phone" >
      </div>
       <div class="col-lg-3">
         <a routerLink="/admin/addCustomer" class="btn btn-warning w-100"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add customer</a>
       </div>
     </div>
   </div>
   <div>
    <table class="table table-striped table-border mt-4">
      <thead>
        <tr>
          <th class="customeWidth">#</th>
          <th>First name</th>
          <th>Last name</th>
          <th>Phone</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of _ar; let i = index">
          <td class="w-25"><span *ngIf="i < 9">0</span>{{i + 1}}
            <a routerLink="/admin/customerInfo/{{item.id}}">
            <i class="fa fa-eye ms-3" aria-hidden="true"></i></a>
            <a routerLink="/admin/customerEdit/{{item.id}}">
            <i class="fa fa-pencil" aria-hidden="true"></i></a>
            <i (click)="delCustomer(item.id)" class="fa fa-trash" aria-hidden="true"></i>
          </td>
          <td>{{ item.first}}</td>
          <td>{{ item.last}}</td>
          <td>{{ item.phone}}</td>
          <td>{{ item.email}}</td>
        </tr>
      </tbody>
    </table>
  </div>